import React, { createContext, useState, useContext } from 'react';

const MRNContext = createContext();

export function MRNProvider({ children }) {
  // 1. Initialize state synchronously right out of disk storage on app boot
  const [mrn, setInternalMrn] = useState(() => {
    return sessionStorage.getItem('patientMrn') || null;
  });

  // 2. This is the absolute controller wrapper that syncs both worlds
  const updateMrn = (newMrn) => {
    setInternalMrn(newMrn); // Update React memory
    if (newMrn) {
      sessionStorage.setItem('patientMrn', newMrn); // Update physical disk
    } else {
      sessionStorage.removeItem('patientMrn');
    }
  };

  return (
    // 3. Explicitly pass down updateMrn as the setMrn operator
    <MRNContext.Provider value={{ mrn, setMrn: updateMrn }}>
      {children}
    </MRNContext.Provider>
  );
}

export function useMRN() {
  const context = useContext(MRNContext);
  if (!context) {
    throw new Error('useMRN must be used within MRNProvider');
  }
  return context;
}